<template>
  <v-card>
    <v-card-title>
      <h3
        >Invoice and Service Confirmation - Wyoming State Loan Repayment
        Program</h3
      >
    </v-card-title>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12
          >In order to receive payment from the Wyoming State Loan Repayment
          Program (WYSLRP), you must complete and submit this form no sooner
          than ninety (90) days from the Effective Date of this Agreement (date
          of the last signature attached to the Agreement).</v-flex
        >
      </v-layout>
      <br />
      <v-flex xs12 style="text-align: left"
        >Healthcare Provider Information</v-flex
      >
      <v-divider></v-divider>
      <v-layout row wrap>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Name"
            :value="`${service.Application.HealthCareProvider.LastName}, ${service.Application.HealthCareProvider.FirstName}, ${service.Application.HealthCareProvider.MiddleName}`"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Email"
            :value="service.Application.HealthCareProvider.WorkEmail"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Address"
            :value="
              service.Application.HealthCareProvider.Address.RAddressLine1
            "
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="City, State, Zip"
            :value="`${service.Application.HealthCareProvider.Address.RCity}, ${service.Application.HealthCareProvider.Address.RState}, ${service.Application.HealthCareProvider.Address.RZip}`"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Home Phone"
            :value="service.Application.HealthCareProvider.CellPhone"
            mask="(###)###-####"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Work Phone"
            :value="service.Application.HealthCareProvider.WorkPhone"
            mask="(###)###-####"
            readonly
          ></v-text-field>
        </v-flex>
      </v-layout>
      <br />
      <v-flex xs12 style="text-align: left">Payment Request</v-flex>
      <v-divider></v-divider>
      <v-layout row wrap>
        <v-flex xs12
          >I understand I must make a lump-sum payment(s) in an amount equal to
          the payment received under the Wyoming State Loan Repayment Program to
          the educational loan(s) approved in my application, and submit Proof
          of Educational Loan Repayment, and all required supporting
          documentation to the Agency no later than August 15th. Failure to do
          so may result in a determination of default and I will incur a debt to
          the Agency in accordance with Attachment A, Statement of Work.</v-flex
        >
      </v-layout>
      <br />
      <v-flex xs12 style="text-align: left">Practice Site Information</v-flex>
      <v-divider></v-divider>
      <v-layout row wrap>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Site Name"
            :value="
              primarySiteName(service.Application.PracticeSiteInformation)
            "
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Medical Director"
            :value="
              primarySite(service.Application.PracticeSiteInformation)
                .MedicalDirectorName
            "
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 pr-4>
          <v-text-field
            label="Site Contact"
            :value="
              primarySite(service.Application.PracticeSiteInformation)
                .SiteContactNameTitle
            "
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Address"
            :value="
              primarySite(service.Application.PracticeSiteInformation)
                .SiteAddress.Address1
            "
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="City, State, Zip"
            :value="`${
              primarySite(service.Application.PracticeSiteInformation)
                .SiteAddress.City
            }, ${
              primarySite(service.Application.PracticeSiteInformation)
                .SiteAddress.State
            }, ${
              primarySite(service.Application.PracticeSiteInformation)
                .SiteAddress.Zip
            }`"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Phone Number"
            :value="
              primarySite(service.Application.PracticeSiteInformation).Phone
            "
            mask="(###)###-####"
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Email for Contact"
            :value="
              primarySite(service.Application.PracticeSiteInformation).Email
            "
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 pr-4>
          <v-text-field
            label="Date of Employment"
            :value="
              primarySite(service.Application.PracticeSiteInformation)
                .EmploymentDate | formattedDate
            "
            readonly
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Hours Worked per Week"
            v-model="service.HoursWorkedWeek"
            :readonly="!isFacilitator"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Direct Patient Care Hours per Week"
            v-model="service.HoursDirectPatientCare"
            :readonly="!isFacilitator"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Number of Days Worked per Week"
            v-model="service.DaysWorked"
            :readonly="!isFacilitator"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 pr-4>
          <v-text-field
            label="Hours Worked per Day"
            v-model="service.HoursWorkedDay"
            :readonly="!isFacilitator"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <br />
      <v-flex xs12 style="text-align: left">Certification</v-flex>
      <v-divider></v-divider>
      <v-layout row wrap>
        <v-flex xs12 pr-4
          >I certify the above named healthcare provider has begun full-time
          employment at the above named practice site and the healthcare
          provider’s full-time service meets and will continue to meet the
          Clinical Service Requirements set forth in Attachment A, Statement of
          Work.</v-flex
        >
        <v-flex xs12 v-for="a in applicantSubmittal" :key="a.ID">
          <v-layout
            row
            wrap
            v-if="
              service.Application.User.RoleID != 1 &&
              service.CurrentStatus.Status.Description != 'New'
            "
          >
            <v-flex xs12 md6 pr-4>
              <v-text-field
                label="Healthcare Provider"
                :value="`${a.User.FirstName} ${a.User.LastName}`"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 pr-4>
              <v-text-field
                label="Date"
                :value="a.ChangedOn | formattedDate"
                readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 v-for="s in siteApproval" :key="s.ID">
          <v-layout
            row
            wrap
            v-if="
              service.Application.User.RoleID != 1 &&
              service.CurrentStatus.Status.Description != 'New'
            "
          >
            <v-flex xs12 md6 pr-4>
              <v-text-field
                label="Site Facilitator"
                :value="`${s.User.FirstName} ${s.User.LastName}`"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 pr-4>
              <v-text-field
                label="Date"
                :value="s.ChangedOn | formattedDate"
                readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 v-for="s in adminApproval" :key="s.ID">
          <v-layout
            row
            wrap
            v-if="
              service.Application.User.RoleID != 1 &&
              service.CurrentStatus.Status.Description != 'New'
            "
          >
            <v-flex xs12 md6 pr-4>
              <v-text-field
                label="Admin"
                :value="`${s.User.FirstName} ${s.User.LastName}`"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6 pr-4>
              <v-text-field
                label="Date"
                :value="s.ChangedOn | formattedDate"
                readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-btn
        v-if="applicantCanSubmitConfirmation"
        @click="verifyConfirmation"
        color="primary"
        >Verify service confirmation</v-btn
      >
      <v-btn
        v-if="FacilitatorCanSubmitConfirmation"
        @click="submitConfirmation"
        color="primary"
        >Submit service confirmation</v-btn
      >
      <v-btn
        v-if="FacilitatorCanReSubmitConfirmation"
        @click="ResubmitConfirmation"
        color="primary"
        >ReSubmit service confirmation</v-btn
      >
      <v-btn
        v-if="ApprovedServiceConfirmation"
        @click="approveConfirmation"
        color="primary"
        >Approve service confirmation</v-btn
      >

      <v-btn color="secondary" @click="closeService">Close</v-btn>
      <v-btn color="primary" outline @click="print">Print</v-btn>

      <v-dialog v-model="verified" width="500">
        <v-card>
          <v-card-text>You have verified the service confirmation.</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="verified = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="Submit" width="500">
        <v-card>
          <v-card-text
            >You have submitted the service confirmation.</v-card-text
          >
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="Submit = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="Approved" width="500">
        <v-card>
          <v-card-text>You have approved the service confirmation.</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="Approved = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
import { authComputed } from '@state/helpers'
import { mapGetters, mapActions } from 'vuex'

import moment from 'moment'
import Printd from 'printd'
export default {
  props: {
    service: Object,
  },
  data() {
    return {
      verified: false,
      Submit: false,
      Approved: false,
      // service: {},
    }
  },
  created() {},
  methods: {
    ...mapActions('errors', ['handleError']),
    // openService(item) {}
    // currentStatus(statuses) {
    //   console.log(statuses)
    //   //debugger
    //   if (statuses && statuses.length > 0) {
    //     let sorted = statuses.sort((a, b) => {
    //       if (a.ChangedOn > b.ChangedOn) {
    //         return -1
    //       }
    //       if (a.ChangedOn < b.ChangedOn) {
    //         return 1
    //       }
    //       return 0
    //     })
    //     console.log(sorted[0].Status.Description)
    //     return sorted[0].Status.Description
    //   }
    //   return 'Not Submitted'
    // },
    primarySiteName(sites) {
      let name = ''
      sites.forEach((i) => {
        if (i.IsPrimarySite) {
          name = i.SiteAddress.SiteInsitutionName
        }
      })
      return name
    },
    print() {
      const d = new Printd()
      d.print(this.$el, [
        `.v-input {
          width: 100%;
    font-size: 16px;
    text-align: left;
}`,
        `.v-input .v-label {
    width: 50%;
}
`,
        `.v-input input {
  
  margin-left: 50%;
  width: 50%;
    max-height: 32px;
        border-style: none;
}`,
        `.v-card__actions, .v-icon {
    display: none;
}`,
      ])
    },
    primarySite(sites) {
      let site = {}
      sites.forEach((i) => {
        if (i.IsPrimarySite) {
          site = i
        }
      })
      return site
    },
    closeService() {
      this.$emit('closeService')
    },
    verifyConfirmation() {
      //debugger
      axios
        .post(`ServiceConfirmation/New/${this.service.ID}`, this.service)
        .then((response) => {
          // this.service = response.data
          this.$emit('saved', response.data)
          this.verified = true
        })
        .catch((error) => {
          console.log(error)
          this.handleError(error)
        })
    },

    submitConfirmation() {
      axios
        .post(`ServiceConfirmation/Submit/${this.service.ID}`, this.service)
        .then((response) => {
          // this.service = response.data
          this.$emit('saved', response.data)
          this.Submit = true
        })
        .catch((error) => {
          console.log(error)
          this.handleError(error)
        })
    },
    ResubmitConfirmation() {
      axios
        .post(`ServiceConfirmation/Submit/${this.service.ID}`, this.service)
        .then((response) => {
          // this.service = response.data
          this.$emit('saved', response.data)
          this.Submit = true
        })
        .catch((error) => {
          console.log(error)
          this.handleError(error)
        })
    },
    approveConfirmation() {
      axios
        .get(`ServiceConfirmation/Approve/${this.service.ID}`)
        .then((response) => {
          // this.service = response.data
          this.$emit('saved', response.data)
          this.Approved = true
        })
        .catch((error) => {
          console.log(error)
          this.handleError(error)
        })
    },
    //can submit button shows when it is time to submit which is 90days for service  confirmation
  },
  computed: {
    ...authComputed,
    year() {
      let datereward = moment(this.service.Application.DateReward)
      let checkdate = moment().month(7).date(15)
      if (datereward > checkdate)
        return moment(checkdate).add(1, 'year').format('YYYY')
      else return moment(checkdate).format('YYYY')
    },
    applicantCanSubmitConfirmation() {
      return (
        this.isApplicant &&
        this.canSubmit &&
        this.currentStatusDescription == 'New' &&
        //most recent status was not from applicant
        this.currentStatusUser.RoleID != 2
      )
    },

    FacilitatorCanSubmitConfirmation() {
      //debugger
      return (
        this.isFacilitator &&
        this.currentStatusDescription == 'New' &&
        this.canVerify &&
        this.canSubmit
      )
    },

    FacilitatorCanReSubmitConfirmation() {
      return (
        this.isFacilitator &&
        this.currentStatusDescription == 'Submitted' &&
        this.canSubmit
      )
    },
    ApprovedServiceConfirmation() {
      return (
        this.isAdmin &&
        this.currentStatusDescription == 'Submitted' &&
        this.canSubmit
      )
    },
    sortedStatuses() {
      let statuses = JSON.parse(
        JSON.stringify(this.service.ServiceConfirmation_Status)
      )
      statuses.sort((a, b) => {
        return Date.parse(b.ChangedOn) - Date.parse(a.ChangedOn)
      })
      return statuses
    },
    canSubmit() {
      if (this.service && this.service.Application) {
        let start = moment(this.service.Application.DateReward).add(60, 'days')
        console.log(moment(start).format('MM/DD/YYYY'))
        if (moment(new Date()) > start) {
          return true
        }
      }
      return false
    },
    canVerify() {
      //debugger
      let start
      let status = this.currentStatusUser.RoleID
      return status != 1
    },
    currentStatus() {
      if (this.sortedStatuses && this.sortedStatuses.length > 0) {
        console.log(this.sortedStatuses[0])
        return this.sortedStatuses[0]
      }
      return null
    },
    currentStatusDescription() {
      if (this.currentStatus) {
        console.log(this.currentStatus.Status.Description)
        return this.currentStatus.Status.Description
      }
      return 'Not Submitted'
    },
    currentStatusUser() {
      if (this.currentStatus) {
        console.log(this.currentStatus.User)
        return this.currentStatus.User
      }
      return 'Not Submitted'
    },
    applicantSubmittal() {
      let statuses = JSON.parse(
        JSON.stringify(this.service.ServiceConfirmation_Status)
      )
      statuses = statuses.filter((i) => {
        return i.Status.Description == 'New'
      })
      statuses.sort((a, b) => {
        return new Date(b.ChangedOn) - new Date(a.ChangedOn)
      })
      if (statuses.length > 0) {
        return [statuses[0]]
      } else {
        return []
      }
    },

    adminApproval() {
      let statuses = JSON.parse(
        JSON.stringify(this.service.ServiceConfirmation_Status)
      )
      statuses = statuses.filter((i) => {
        return i.Status.Description == 'Approved'
      })
      statuses.sort((a, b) => {
        return new Date(b.ChangedOn) - new Date(a.ChangedOn)
      })
      if (statuses.length > 0) {
        return [statuses[0]]
      } else {
        return []
      }
    },

    siteApproval() {
      let statuses = JSON.parse(
        JSON.stringify(this.service.ServiceConfirmation_Status)
      )
      statuses = statuses.filter((i) => {
        return i.Status.Description == 'Submitted'
      })
      statuses.sort((a, b) => {
        return new Date(b.ChangedOn) - new Date(a.ChangedOn)
      })
      if (statuses.length > 0) {
        return [statuses[0]]
      } else {
        return []
      }
    },
  },
}
</script>

<style></style>
